import type { ThemeName } from '@/types';
import { useUiLanguage } from '@/utils/i18n';

export const useSettingsStore = defineStore(
  'uiSettings',
  () => {
    const language = useUiLanguage();
    const timezone = ref('Asia/Shanghai');
    const timezoneDisplayVersion = ref(0);
    const currentTheme = ref<ThemeName>('light');

    const isDarkTheme = computed(() => ['dark', 'bootstrap_dark'].includes(currentTheme.value));
    const chartTheme = computed<'dark' | 'light'>(() => (isDarkTheme.value ? 'dark' : 'light'));

    const uiVersion = computed(() => __COMMIT_HASH__.trim());

    return {
      language,
      timezone,
      timezoneDisplayVersion,
      currentTheme,
      isDarkTheme,
      chartTheme,
      uiVersion,
    };
  },
  {
    persist: {
      key: 'ftUISettings',
      pick: ['language', 'timezone', 'timezoneDisplayVersion', 'currentTheme'],
      afterHydrate: ({ store }) => {
        if (store.timezoneDisplayVersion < 1) {
          store.timezone = 'Asia/Shanghai';
          store.timezoneDisplayVersion = 1;
          store.$persist();
        }
      },
    },
  },
);

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot));
}
